import { Feature, FeatureFlag } from '@nirvana/shared/constants';
import { EnumUtils } from '../../utils/enum.utils';
import { CompanyFeatures } from '../../company/types/company-data';
import { CompanyLicenseInformation } from './CompanyLicenseInformation';

export enum MonthlyProductType {
  EndpointSecurity = 0, // Default Product
  BitdefenderEdr = 3, // Companion
}

export namespace MonthlyProductType {
  const productTypeToDelegateFeatureId: { [productType in MonthlyProductType]: Feature } = {
    [MonthlyProductType.EndpointSecurity]: Feature.PRODUCT_FEATURE_DEFAULT_PRODUCT_DELEGATE,
    [MonthlyProductType.BitdefenderEdr]: Feature.PRODUCT_FEATURE_COMPANION_PRODUCT_DELEGATE,
  };

  export function getAllProductTypes(): MonthlyProductType[] {
    return EnumUtils.GetValues<MonthlyProductType>(MonthlyProductType);
  }

  export function getDelegateFeatureId(productType: MonthlyProductType): Feature {
    return productTypeToDelegateFeatureId[productType];
  }

  export function getDelegateFeatureNameForProductType(productType: MonthlyProductType): FeatureFlag {
    const featureId = MonthlyProductType.getDelegateFeatureId(productType);

    return Feature.getFeatureFlag(featureId);
  }

  export function getAssignedProduct(features: CompanyFeatures): MonthlyProductType {
    if (features[FeatureFlag.PRODUCT_FEATURE_COMPANION_USABLE]) {
      return MonthlyProductType.BitdefenderEdr;
    }

    return MonthlyProductType.EndpointSecurity;
  }

  export function getDelegableProducts(features: CompanyFeatures): MonthlyProductType[] {
    return getAllProductTypes().filter(product => {
      return features[productTypeToDelegateFeatureId[product]];
    });
  }

  export function getProductsAvailability(
    licenseInfo: CompanyLicenseInformation
  ): { [type in MonthlyProductType]: boolean } {
    const delegableProducts = CompanyLicenseInformation.getParentDelegableProducts(licenseInfo);
    const productsAvailability = {};

    for (const monthlyProduct of getAllProductTypes()) {
      productsAvailability[monthlyProduct] = delegableProducts.includes(monthlyProduct);
    }

    // @ts-ignore
    return productsAvailability;
  }
}
